import React from "react";
import { useReveal } from "./useReveal";
import { optimized } from "./img";
import { useContent } from "../../ContentContext";

const DEFAULT_ITEMS = [
    { title: "East Coast Lobster Roll", img: "https://customer-assets.emergentagent.com/job_local-strake/artifacts/kjrwnnt1_photo_2026-05-14%2011.48.14.jpeg", label: "Customer Favourite", desc: "REAL lobster & crab with tarragon, lemon zest, crispy potato, dill butter & pea shoots.", tag: "Seafood" },
    { title: "Farmhouse Griller", img: "https://customer-assets.emergentagent.com/job_local-strake/artifacts/9x6b1z01_photo_2026-05-14%2011.48.35.jpeg", label: "Strake Signature", desc: "Breaded chicken, braised pork, smoked pork belly, cheddar, BBQ aioli, crispy onions & arugula.", tag: "Stacked" },
    { title: "Stampede Dog", img: "https://customer-assets.emergentagent.com/job_local-strake/artifacts/69r51vdd_photo_2026-05-14%2011.48.06.jpeg", label: "Classic. Jumbo. Loaded.", desc: "Classic jumbo hot dog topped with ketchup, mustard, onions & pickles. Pair with lobster loaded tots.", tag: "Classic" },
    { title: "Crispy Chicken Crunch", img: "https://customer-assets.emergentagent.com/job_local-strake/artifacts/dn334i6f_IMG_5061.JPG", label: "Crispy & Loaded", desc: "Double-breaded chicken thigh, maple glaze, sriracha aioli, apple slaw & dill pickles.", tag: "Must Try" },
];

const Card = ({ item, index }) => {
    const ref = useReveal();
    return (
        <div ref={ref} className="fade-in" data-testid={`favourite-card-${index}`}>
            <div className="relative overflow-hidden">
                <img
                    src={optimized(item.img, { w: 800, q: 80 })}
                    alt={item.title}
                    className="w-full aspect-square object-cover transition-transform duration-[1200ms] hover:scale-105"
                    loading="lazy"
                    decoding="async"
                />
                <div className="absolute top-4 left-4 bg-[#1A1A1A] text-[#F5F2EB] text-[10px] uppercase tracking-[0.25em] font-semibold px-3 py-1.5 font-body">
                    {item.label}
                </div>
                <div className="absolute top-4 right-4 bg-[#E8A87C] text-[#1A1A1A] text-[10px] uppercase tracking-[0.2em] font-bold px-2.5 py-1 font-body">
                    {item.tag}
                </div>
            </div>
            <div className="pt-5 pb-2">
                <div className="text-[10px] uppercase tracking-[0.35em] text-[#C65A2C] font-semibold mb-2 font-body">
                    No. {String(index + 1).padStart(2, "0")}
                </div>
                <h3 className="font-display text-3xl sm:text-4xl uppercase font-bold leading-tight tracking-tight text-[#1A1A1A]">
                    {item.title}
                </h3>
                <p className="mt-3 text-[#3a3a3a] text-sm sm:text-base leading-relaxed font-body">
                    {item.desc}
                </p>
            </div>
        </div>
    );
};

export const Favourites = () => {
    const { content } = useContent();
    const items = (content?.favourites?.items && content.favourites.items.length > 0) ? content.favourites.items : DEFAULT_ITEMS;
    const sectionTitle = content?.favourites?.kicker || "The Menu Highlights";
    const heading1 = content?.favourites?.heading1 || "Customer";
    const heading2 = content?.favourites?.heading2 || "favourites";
    const subtitle = content?.favourites?.subtitle || "Most loved by Collingwood locals.";
    return (
        <section
            data-testid="favourites-section"
            className="bg-[#EFE7DB] pt-8 pb-12 px-6 relative grain"
        >
            {/* Editorial header block */}
            <div className="mb-10">
                <div className="flex items-center gap-3 mb-5">
                    <div className="h-[2px] w-8 bg-[#C65A2C]" />
                    <div className="font-body text-[10px] uppercase tracking-[0.45em] font-semibold text-[#C65A2C]">
                        {sectionTitle}
                    </div>
                </div>

                <h2 className="font-display text-[64px] sm:text-[88px] uppercase font-bold leading-[0.88] tracking-tight text-[#1A1A1A]">
                    {heading1}
                </h2>

                <div className="flex items-baseline gap-3 mt-1">
                    <div className="font-vintage italic text-[32px] sm:text-[44px] text-[#C65A2C] leading-none lowercase tracking-tight">
                        {heading2}
                    </div>
                    <div className="h-px flex-grow bg-[#1A1A1A]/25" />
                </div>

                <p className="mt-5 font-body text-sm sm:text-base text-[#3a3a3a]/85 italic leading-relaxed max-w-md">
                    {subtitle}
                </p>
            </div>

            <div className="flex flex-col gap-10">
                {items.map((item, i) => (
                    <Card key={item.title || i} item={item} index={i} />
                ))}
            </div>
        </section>
    );
};
